<div class="custom-dialog-content first-time">
  <h2><strong>Instrucciones</strong></h2>
  <ul>
    <li>1- Debes crear a quien le vas a enviar ese presupuesto, o sea, el destinatario. Lo hacemos con nuevo contacto.
      También los creamos desde el menú contactos</li>
    <li>2- El numero de presupuesto se autocompleta. Si quieres que la numeración sea distinta, la puedes cambiar desde
      menú configuración/actividad
    </li>
    <li>3- En cuanto a la fecha, Por defecto sale la fecha de hoy, pero la puedes cambiar. Eso sí, por ley, las facturas
      son correlativas en fecha y numero, nunca podrás hacer una factura de ayer o del mes pasado.
    </li>
    <li>4- La cuenta contable de ingreso depende de que vendas, productos y mercancías (por ejemplo, un comercio) o si
      prestas servicios (por ejemplo, un abogado, o un restaurante). Indícalo.</li>
    <li>5- Tipo de cobro; como quieres cobrar, por transferencia a tu banco, en efectivo. Créalos una vez y se quedan
      guardados en menú finanzas.</li>
    <li>6- Añadir concepto: es lo que facturamos. Los puedes crear desde el menú conceptos. Si no los tienes creados,
      escríbelos ahora. Aquí le aplicamos los impuestos que estamos obligados a aplicar en nuestras facturas, IVA/IGIC e
      IRPF.</li>
    <li>7- Guardarlo y se nos crea. En los tres puntitos tenemos opciones para hacer sobre ese presupuesto, como
      convertirla en factura.</li>
  </ul>

  <mat-checkbox name="checked" [(ngModel)]="no_show_next_time" required>
    No volver a mostrar
  </mat-checkbox>

  <button mat-stroked-button class="btn-convfact  me-3 pull-right" (click)="accept()">
    Aceptar
  </button>

</div>
